import React from "react";

// POS home-screen quantity multiplier (rvQuantityVertical, span 2) + Custom cell.
// selectedProductQuantity: 2x..5x toggle it (tap active → back to 1); Custom opens a numpad dialog.
// An active multiplier is a MODE — the next tap adds N units — so it is stated in the label and
// announced via aria-pressed rather than relying on colour alone.
const MULTS = [2, 3, 4, 5]; // 2x–5x then Custom (user: 6x–11x dropped 08-27)

export default function MultiplierColumn({ value, onSelect, onCustom, customQty = null }) {
  // Android setupCustomQuantityDialog: after Apply the chips DESELECT and the button reads "Custom (N)" —
  // even when N equals a chip value — until the next add resets it (resetQuantity → "Custom").
  const customActive = customQty != null && customQty > 0;
  const chipOn = (n) => !customActive && value === n;
  // Custom lives INSIDE the same grid (spanning the last two cells of the second row) rather than as
  // a separate full-width button. It is the same kind of control, and folding it in keeps the whole
  // multiplier block to exactly two rows — height the keypad and the action buttons need more.
  return (
    <div className="qv-mults" role="group" aria-label="Quantity multiplier">
      {MULTS.map((n) => (
        <button
          key={n}
          type="button"
          className={chipOn(n) ? "qv-btn is-on qv-num" : "qv-btn qv-num"}
          aria-pressed={chipOn(n)}
          onClick={() => onSelect(chipOn(n) ? 1 : n)}
        >
          {n}x
        </button>
      ))}
      <button
        type="button"
        className={customActive ? "qv-btn is-on qv-mult-custom" : "qv-btn qv-mult-custom"}
        aria-pressed={customActive}
        onClick={onCustom}
      >
        {customActive ? `Custom (${customQty})` : "Custom"}
      </button>
    </div>
  );
}
